<template>
  <div>
    <Header />
    <Breadcrumbs title="ORDER HISTORY" />
     <section class="p-0" v-if="!order_history">
      <div class="container">
        <img
          :src='require("@/assets/images/ajax-loader.gif")'
          class="img-fluid bg-img w-100"
        />
      </div>
    </section>
    <section class="section-b-space">
      <div class="container">
        <div class="checkout-page">
          <div class="checkout-form history-overflow">
            <table class="table cart-table table-responsive-xs">
              <thead class="table-head">
                <tr>
                  <th>Order ID</th>
                  <th>Subtotal</th>
                  <th>Tax&Fees(i)</th>
                  <th>Delivery</th>
                  <th>Total</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody class="orderhistory-table-body">
                <tr v-for="order in order_history" v-bind:key="order.internal_order_id">
                  <td style="color:#24B34C; font-weight:500;cursor: pointer;" v-b-modal="'modal-history-order-detail'+order.internal_order_id">#{{order.order_data.ordernumber}}</td>
                  <td v-for="tax_web_line in order.order_data.web_total_lines" v-bind:key="tax_web_line.text">
                    <div style="color:#24B34C; font-weight:500;cursor: pointer;" v-if="tax_web_line.type=='taxesfees'" v-b-modal="'modal-history-detail'+order.internal_order_id">{{tax_web_line.value_show}}</div>
                    <div style="color:#24B34C; font-weight:500;cursor: pointer;" v-else-if="tax_web_line.type=='subtotal'" v-b-modal="'modal-history-subtotal-detail'+order.internal_order_id">{{tax_web_line.value_show}}</div>
                    <div v-else>{{tax_web_line.value_show}}</div>
                  </td>
                  <td>{{order.order_day_format}}</td>
                  <b-modal
                  :id="`modal-history-detail${order.internal_order_id}`"
                  size="lg"
                  centered
                  :hide-footer="true" >
                    <div class="tax-fee-title">{{webTotalTitle}}</div>
                    <table style="border-bottom: 1px solid #bdbdbd; margin-bottom: 15px;" align="center">
                      <thead>
                        <tr>
                          <td class="tax-fee-header">DETAIL</td>
                          <td class="tax-fee-header">DESCRIPTION</td>
                          <td class="tax-fee-header">PRICE</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="tax_web_detail in order.order_data.web_total_details" v-bind:key="tax_web_detail.text">
                          <td>{{tax_web_detail.text}}</td>
                          <td class="tf-margin">{{tax_web_detail.description}}</td>
                          <td>{{tax_web_detail.value_show}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </b-modal>

                  <b-modal
                  :id="`modal-history-subtotal-detail${order.internal_order_id}`"
                  size="md"
                  centered
                  :hide-footer="true" >
                    <div class="tax-fee-title">Subtotal Details</div>
                    <table style="border-bottom: 1px solid #bdbdbd; margin-bottom: 15px;" align="center">
                      <tbody>
                        <tr>
                          <ul class="qty qty-history"  v-if="order.order_data.items.length">
                            <li v-for="(item,index) in order.order_data.items" :key="index">
                              <div class="row" style="margin-bottom:25px;margin-top: 5px;">
                                <div class="col-4" style="height:unset;">
                                    <img
                                      :src='item.image_url_small'
                                      class="mr-3 rrr-img w-100"
                                      :alt="item.desc"
                                    />
                                </div>
                                <div class="col-8" style="margin-top:-5px;">
                                    <div class="row"><div class="col-12">{{ item.desc }}</div></div>
                                    <div class="row">
                                      <div class="col-6">Qty : {{item.qty}}</div>
                                      <div class="col-6" style="text-align: right;">{{ item.single_price_show }}</div>
                                    </div>
                                    <div class="row">
                                      <div class="col-8">Discount Code :</div>
                                      <div class="col-4" style="text-align: right;height:unset;">{{item.discount_code}}</div>
                                    </div>
                                    <div class="row">
                                      <div class="col-6">Discount:</div>
                                      <div class="col-6" style="text-align: right;">{{item.discount_qty_amount_show}} Off</div>
                                    </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </tr>
                      </tbody>
                    </table>
                  </b-modal>

                  <b-modal
                  :id="`modal-history-order-detail${order.internal_order_id}`"
                  size="md"
                  centered
                  :hide-footer="true" >
                    <div class="tax-fee-title" style = "border-bottom: none;margin-bottom:10px;">Order Details #{{order.order_data.ordernumber}}</div>
                    <div class="tax-fee-title" style = "padding-bottom: 10px;margin-bottom:20px;">{{order.order_date_format}}</div>
                    <table style="border-bottom: 1px solid #bdbdbd; margin-bottom: 15px;" align="center">
                      <tbody>
                        <tr>
                          <ul class="qty qty-history"  v-if="order.order_data.items.length">
                            <li v-for="(item,index) in order.order_data.items" :key="index">
                              <div class="row" style="margin-bottom:25px;margin-top: 5px;">
                                <div class="col-4" style="height:unset;">
                                    <img
                                      :src='item.image_url_small'
                                      class="mr-3 rrr-img w-100"
                                      :alt="item.desc"
                                    />
                                </div>
                                <div class="col-8" style="margin-top:-5px;">
                                    <div class="row"><div class="col-12">{{ item.desc }}</div></div>
                                    <div class="row">
                                      <div class="col-6">Qty : {{item.qty}}</div>
                                      <div class="col-6" style="text-align: right;">{{ item.single_price_show }}</div>
                                    </div>
                                    <div class="row" style="font-size:14px;">
                                      <div class="col-8">Discount Code :</div>
                                      <div class="col-4" style="text-align: right;height:unset;">{{item.discount_code}}</div>
                                    </div>
                                    <div class="row" style="font-size:14px;">
                                      <div class="col-6">Discount:</div>
                                      <div class="col-6" style="text-align: right;">{{item.discount_qty_amount_show}} Off</div>
                                    </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </tr>
                      </tbody>
                    </table>
                    <table class="sub-total" style="width:100%;" align="center" v-if="order.order_data.items.length">
                        <thead>
                          <tr style="line-height:28px;font-weight:500;font-size:14px;" v-for="tax_web_line in order.order_data.web_total_lines" v-bind:key="tax_web_line.text">
                            <td v-if="tax_web_line.type=='taxesfees'"  v-b-modal="'modal-history-detail'+order.internal_order_id">
                                {{tax_web_line.text}}
                            </td>
                            <td v-else>{{tax_web_line.text}}</td>
                            <td style="text-align:right;">
                              <div :style="tax_web_line.style=='crossed'?'text-decoration: line-through;':tax_web_line.style=='bold'?'font-weight: bold;':'font-style: normal;'">{{tax_web_line.value_show}}</div>
                            </td>
                          </tr>
                        </thead>
                      </table>

                      <table class="sub-total" style="width:100%;">

                        <thead v-if="order.order_data.is_pickup">
                          <tr style="height: 50px;border-bottom: 1px solid #bdbdbd;">
                            <template v-if="order.order_data.is_drive_trough">
                            <td style="margin-top: 20px; font-weight: 600; font-size: 15px;color: #666; width:100%;">DRIVE TROUGH</td>
                            </template>
                            <template v-else>
                              <td style="margin-top: 20px; font-weight: 600; font-size: 15px;color: #666; width:100%;">PICKUP</td>
                            </template>
                            <td></td>
                          </tr>
                        </thead>

                        <thead v-else>
                        <tr style="height: 50px;border-bottom: 1px solid #bdbdbd;">
                          <td style="margin-top: 20px; font-weight: 600; font-size: 15px;color: #666; width:100%;">DELIVERY ADDRESS</td>
                          <td></td>
                        </tr>
                        </thead>
                      </table>

                      <table class="sub-total" style="width:100%;">
                        <tfoot>
                          <tr style="line-height:28px;font-weight:500;font-size:14px;" v-for="(address,index) in order.delivery_address" v-bind:key="address.index">
                              <td style="width:25%" v-if="index=='address1'">
                                Address:
                              </td>
                              <td style="text-align:right;width:80%" v-if="index=='address1'">{{address}}</td>
                              <td style="width:25%" v-if="index=='city'">
                                City:
                              </td>
                              <td style="text-align:right;width:80%" v-if="index=='city'">{{address}}</td>
                              <td style="width:25%" v-if="index=='state'">
                                State:
                              </td>
                              <td style="text-align:right;width:80%" v-if="index=='state'">{{address}}</td>
                              <td style="width:25%" v-if="index=='zip'">
                                ZIP Code:
                              </td>
                              <td style="text-align:right;width:80%" v-if="index=='zip'">{{address}}</td>
                          </tr>
                          <!-- {{address1(order.delivery_address)}} -->
                        </tfoot>
                      </table>


                  </b-modal>
<!--                  <div class="col-sm-12 empty-cart-cls text-center" v-if="!order.order_data.items.length">-->
<!--                    <img :src='"@/assets/images/icon-empty-cart.png"' class="img-fluid" alt="empty cart" />-->
<!--                    <h3 class="mt-3">-->
<!--                      <strong>Your history is Empty</strong>-->
<!--                    </h3>-->
<!--                    <div class="col-12">-->
<!--                      <router-link :to="{ path: '/shop'}" class="btn btn-solid">go shopping</router-link>-->
<!--                    </div>-->
<!--                  </div>-->

                </tr>
              </tbody>

            </table>

          </div>

        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Header from '@/components/header'
import Footer from '@/components/footer'
import Breadcrumbs from '@/components/widgets/breadcrumbs'
import * as api from '@/api'

export default {
  data() {
    return {
      counter: 1
    }
  },
  components: {
    Header,
    Footer,
    Breadcrumbs
  },
  computed: {
    ...mapGetters({
       order_history:'cart/order_history',
       getDetail: 'products/getProductByProductId',
       getAuth: 'auth/getAccessToken',
       webTotalTitle: 'cart/webTotalTitle'
    })
  },
  methods: {
    address1: function (str) {
      // let answer  = '';
      // const resultArray = Object.keys(str).map(function(key) {
      //   console.log([Number(key), str[key]]);
      // });
      // str.forEach(function (item) {
        // console.log(str);
      //   if(item.types.includes("address1")) {
      //     answer = item.long_name;
      //   }
      // });
      return str;
    }
  },
  async mounted() {
     var  {dispatch} = this.$store
     var orderhistory = await api.orderHistory({limit:20,order_id:''},{'authorization':this.getAuth})
     dispatch('cart/setOrderhistory', orderhistory)
  }

}
</script>
